export const STATE_DEFINITION_COMMON = {
  'users.profile': {
    url: '/{userId:[0-9]+}?tab&unavailabilityId&newSet&documentId',
    reloadOnSearch: false,
    params: {
      unavailabilityCount: null,
      newSet: null,
      editSet: null,
      copySet: null,
    },
    resolve: {
      geo(RestUtils) {
        'ngInject';

        return RestUtils.getGeo();
      },
      user(personaCollection, PersonaCollection, $transition$) {
        'ngInject';

        // Fetch-on-miss: a newly created/imported employee may not yet be in the
        // per-session PersonaCollection cache (e.g. a creation path that bypasses
        // the Users.js interceptor, or a dropped/missed socket:user:new event). Fall
        // back to a direct GET by id so the onEnter guard only 404s for a user that
        // genuinely does not exist. See SCHE-2663 / RF-35987.
        return PersonaCollection.getUser($transition$.params().userId);
      },
      userExtraData(UserUtils, user) {
        'ngInject';

        return UserUtils.getExtraUserData(user);
      },
      previousState($transition$, $state) {
        'ngInject';

        const from = $transition$.from();
        return {
          name: from.name,
          params: { ...$state.params },
        };
      },
    },
    onEnter(user, $state) {
      'ngInject';

      if (!user) {
        $state.go('404', {}, { location: false });
      }
    },
    title: '{{ user.fullname }}',
  },
};

export const DEFAULT_USERS_COLUMNS = [
  { active: true, property: 'employeeId' },
  { active: true, property: 'positions' },
  { active: true, property: 'locations' },
  { active: true, property: 'groups' },
  { active: true, property: 'email' },
  { active: true, property: 'phone' },
  { active: true, property: 'status' },
];

export const USERS_COLUMN_DESCRIPTIONS = {
  name: 'Name',
  employeeId: 'Employee ID',
  positions: 'Positions',
  locations: 'Locations',
  groups: 'Groups',
  email: 'Email',
  phone: 'Phone',
  status: 'Status',
};
